import './StringFilterEditor.less';
import React from "react";
import {translate} from "../../../../i18n";
import typedOperators from "../../config/typedOperators";
import {FilterEditorTemplate} from "../../templates/filter-editor/FilterEditorTemplate";


export default class StringFilterEditor extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            operator: props.defaultOperator ? props.defaultOperator : typedOperators.string[0],
            value: props.defaultValue ? String(props.defaultValue) : '',
            error: null,
        };
    }

    componentDidMount() {
        this.validate();
    }

    setOperator = (operator) => {
        this.setState({
            operator: operator
        }, () => {
            this.validate();
        });
    };

    setValue = (value) => {
        this.setState({
            value: value
        }, () => {
            this.validate();
        });
    };

    validate = () => {
        const {operator, value} = this.state;
        const {vMinLength, vMaxLength} = this.props;

        const valueRequiredOperators = [
            'contain',
            'not_contain',
            'start_with',
            'not_start_with',
            'end_with',
            'not_end_with'
        ];

        if (undefined !== vMinLength && value.length < vMinLength) {
            this.setState({
                error: translate('min_characters{number}', {number: vMinLength})
            });
        }
        else if (undefined !== vMaxLength && value.length > vMaxLength) {
            this.setState({
                error: translate('max_characters{number}', {number: vMaxLength})
            });
        }
        else if (valueRequiredOperators.includes(operator) && value.length === 0) {
            this.setState({
                error: translate('Enter some text')
            });
        }
        else {
            this.setState({
                error: null
            });
        }
    };

    submit = () => {
        const { update } = this.props;
        const { operator, value, error } = this.state;

        if (error !== null) {
            return;
        }

        update(operator, value);
    };

    renderInputComponent = () => {
        const { value } = this.state;

        return <input
            type="text"
            className="value-input"
            defaultValue={value}
            onKeyUp={(event) => this.setValue(event.target.value)}
            onPaste={(event) => this.setValue(event.target.value)}
            onChange={(event) => this.setValue(event.target.value)}
            onKeyDown={(event) => {
                if (event.key === 'Enter') {
                    event.preventDefault();
                    this.submit();
                }
            }}
        />;
    };

    render() {
        const { fieldName } = this.props;
        const { operator, error } = this.state;

        return <div className="string-filter-editor">
            <FilterEditorTemplate
                fieldName={fieldName}
                operator={operator}
                setOperator={this.setOperator}
                availableOperators={typedOperators.string}
                inputComponent={this.renderInputComponent()}
                error={error}
                apply={this.submit}
            />
        </div>;
    }
}
